/**
 * @generated SignedSource<<2561f5a1e950a8f8003b3a0221235814>>
 * @relayHash b436b53cb8f9c7dd92de1adf248fbfbd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fa48c858d7e6d800540ea1b17fa5fc60e0a1ac832f26a5f72595c45706b09c26

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiAdminPagesFieldsQuery } from './uiAdminPagesFieldsQuery.graphql';

const node: PreloadableConcreteRequest<uiAdminPagesFieldsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "fa48c858d7e6d800540ea1b17fa5fc60e0a1ac832f26a5f72595c45706b09c26",
    "metadata": {},
    "name": "uiAdminPagesFieldsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
